import Cropper from 'cropperjs';

globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Media = appCustomerSpace.Modals.Media || {};

appCustomerSpace.Modals.Media.EditImageContent = (function(superClass) {

  utils.extend(EditImageContent, superClass);

  function EditImageContent() {
    EditImageContent.__super__.constructor.apply(this, arguments);

    this.$cropImage = this.$html.find('.crop-source-image');
    this.$validateBtn = this.$html.find('.validate-crop-btn');
    this.$ratioBtns = this.$html.find('.ratio-btn');
    this.$coordX = this.$html.find('.crop-coord-x');
    this.$coordY = this.$html.find('.crop-coord-y');
    this.$coordWidth = this.$html.find('.crop-coord-width');
    this.$coordHeight = this.$html.find('.crop-coord-height');
    this.$aspectRatio = this.$html.find('.crop-aspect-ratio');

    this.imageContentId = this.$html.data('image-content-id');
    this.cropper = null;
    this.stimulusController = this.$html.data('stimulus-controller');
  }

  $.extend(EditImageContent.prototype, {
    init: function() {
      this._initCropper();
      this._initEvents();
      return EditImageContent.__super__.init.apply(this, arguments);
    },

    _initCropper: function() {
      var modal = this;

      if (!this.$cropImage.length) return;

      this.cropper = new Cropper(this.$cropImage[0]);

      var canvas = this.cropper.getCropperCanvas();
      if (canvas) {
        canvas.background = false;
      }

      var shade = canvas ? canvas.querySelector('cropper-shade') : null;
      if (shade) {
        this.$shade = shade;
        shade.style.outline = 'none';
        shade.style.boxShadow = '0 0 0 9999px rgba(0, 0, 0, 0.65)';
      }

      var cropperImage = this.cropper.getCropperImage();
      if (cropperImage) {
        cropperImage.scalable = false;
        cropperImage.$ready(function(image) {
          function fitImage() {
            var cropArea = modal.$html.find('.image-content-crop-area')[0];
            canvas.style.width = cropArea.clientWidth + 'px';
            canvas.style.height = cropArea.clientHeight + 'px';

            cropperImage.scalable = true;
            cropperImage.$setTransform(1, 0, 0, 1, 0, 0);
            cropperImage.$center('contain');
            cropperImage.scalable = false;

            requestAnimationFrame(function() {
              requestAnimationFrame(function() {
                modal._initCropCoords();
              });
            });
          }

          if (cropperImage.offsetWidth === image.naturalWidth) {
            fitImage();
          } else {
            cropperImage.addEventListener('transform', function onHandleLoad() {
              cropperImage.removeEventListener('transform', onHandleLoad);
              requestAnimationFrame(fitImage);
            });
          }
        });
      }

      var selection = this.cropper.getCropperSelection();
      if (selection) {
        var currentRatio = this.$html.data('current-ratio');
        var numericRatio = this._parseRatio(currentRatio);
        if (!isNaN(numericRatio)) {
          selection.aspectRatio = numericRatio;
        }

        selection.addEventListener('change', function(event) {
          event.preventDefault();
          modal._constrainSelection(event.detail);
        });
      }

      if (cropperImage && selection) {
        cropperImage.addEventListener('transform', function() {
          selection.$nextTick(function() {
            modal._constrainSelection({
              x: selection.x,
              y: selection.y,
              width: selection.width,
              height: selection.height
            });
            modal._updateShadeClip();
          });
        });
      }
    },

    _initCropCoords: function(retryCount) {
      retryCount = retryCount || 0;
      var cropperImage = this.cropper ? this.cropper.getCropperImage() : null;

      if (cropperImage) {
        var imageRect = cropperImage.getBoundingClientRect();
        if ((imageRect.width === 0 || imageRect.height === 0) && retryCount < 5) {
          var modal = this;
          requestAnimationFrame(function() {
            modal._initCropCoords(retryCount + 1);
          });
          return;
        }
      }

      var cropCoords = this.$html.data('crop-coords');

      if (cropCoords) {
        this._initSelection(cropCoords);
      } else {
        this._selectFullImage();
      }

      this._updateShadeClip();
    },

    _initEvents: function() {
      var modal = this;

      this.$ratioBtns.on('click', function() {
        var ratio = $(this).data('ratio');

        modal.$ratioBtns.removeClass('btn-primary').addClass('btn-default');
        $(this).removeClass('btn-default').addClass('btn-primary');
        modal.$aspectRatio.val(ratio);

        var selection = modal.cropper ? modal.cropper.getCropperSelection() : null;
        if (selection) {
          var numericRatio = modal._parseRatio(ratio);
          selection.aspectRatio = isNaN(numericRatio) ? NaN : numericRatio;
        }
      });

      this.$validateBtn.on('click', function() {
        modal._submitEdit();
      });

      var canvas = this.cropper ? this.cropper.getCropperCanvas() : null;
      if (canvas) {
        canvas.addEventListener('dblclick', function() {
          modal._selectFullImage();
        });
      }
    },

    _selectFullImage: function() {
      if (!this.cropper) return;

      var selection = this.cropper.getCropperSelection();
      var cropperImage = this.cropper.getCropperImage();
      var canvas = this.cropper.getCropperCanvas();
      if (!selection || !cropperImage || !canvas) return;

      var canvasRect = canvas.getBoundingClientRect();
      var imageRect = cropperImage.getBoundingClientRect();

      var imgX = imageRect.left - canvasRect.left;
      var imgY = imageRect.top - canvasRect.top;
      var imgW = imageRect.width;
      var imgH = imageRect.height;

      var currentRatio = selection.aspectRatio;
      var selW, selH, selX, selY;

      if (currentRatio && !isNaN(currentRatio) && currentRatio > 0) {
        if (imgW / imgH > currentRatio) {
          selH = imgH;
          selW = selH * currentRatio;
        } else {
          selW = imgW;
          selH = selW / currentRatio;
        }
        selX = imgX + (imgW - selW) / 2;
        selY = imgY + (imgH - selH) / 2;
      } else {
        selW = imgW;
        selH = imgH;
        selX = imgX;
        selY = imgY;
      }

      selection.$change(selX, selY, selW, selH);
      selection.$center();
    },

    _parseRatio: function(ratioString) {
      if (!ratioString || ratioString === '') return NaN;
      var parts = String(ratioString).split(':');
      if (parts.length === 2) return parseFloat(parts[0]) / parseFloat(parts[1]);
      return NaN;
    },

    _initSelection: function(cropCoords) {
      var selection = this.cropper.getCropperSelection();
      var cropperImage = this.cropper.getCropperImage();
      var canvasEl = this.cropper.getCropperCanvas();
      if (!cropperImage || !canvasEl) return;

      var canvasRect = canvasEl.getBoundingClientRect();
      var imageRect = cropperImage.getBoundingClientRect();
      if (imageRect.width === 0 || imageRect.height === 0) return;

      var imgX = imageRect.left - canvasRect.left;
      var imgY = imageRect.top - canvasRect.top;

      var pixelX = (cropCoords.left / 100) * imageRect.width + imgX;
      var pixelY = (cropCoords.top / 100) * imageRect.height + imgY;
      var pixelW = (cropCoords.width / 100) * imageRect.width;
      var pixelH = (cropCoords.height / 100) * imageRect.height;

      selection.$change(pixelX, pixelY, pixelW, pixelH, NaN);
    },

    _applyCropCoords: function() {
      if (!this.cropper) return;

      var selection = this.cropper.getCropperSelection();
      var cropperImage = this.cropper.getCropperImage();
      var canvasEl = this.cropper.getCropperCanvas();
      if (!selection || !cropperImage || !canvasEl) return;

      var canvasRect = canvasEl.getBoundingClientRect();
      var imageRect = cropperImage.getBoundingClientRect();
      if (imageRect.width === 0 || imageRect.height === 0) return;

      var imgX = imageRect.left - canvasRect.left;
      var imgY = imageRect.top - canvasRect.top;

      var percentX = ((selection.x - imgX) / imageRect.width) * 100;
      var percentY = ((selection.y - imgY) / imageRect.height) * 100;
      var percentW = (selection.width / imageRect.width) * 100;
      var percentH = (selection.height / imageRect.height) * 100;

      this.$coordX.val(Math.max(0, percentX).toFixed(2));
      this.$coordY.val(Math.max(0, percentY).toFixed(2));
      this.$coordWidth.val(Math.min(100, percentW).toFixed(2));
      this.$coordHeight.val(Math.min(100, percentH).toFixed(2));
    },

    _submitEdit: function() {
      this._applyCropCoords();

      var modal = this;
      var csrfToken = $('meta[name="csrf-token"]').attr('content');
      var stimulusController = modal.stimulusController;

      var updateUrl = stimulusController
        ? stimulusController.createUrlValue + '/' + modal.imageContentId
        : '/media/image_contents/' + modal.imageContentId;

      appCustomerSpace.Loader().start({ $container: modal.$html.find('.modal-content') });

      $.ajax({
        url: updateUrl,
        method: 'PATCH',
        dataType: 'json',
        headers: { 'X-CSRF-Token': csrfToken },
        data: {
          crop_coord_x: modal.$coordX.val(),
          crop_coord_y: modal.$coordY.val(),
          crop_coord_width: modal.$coordWidth.val(),
          crop_coord_height: modal.$coordHeight.val(),
          aspect_ratio: modal.$aspectRatio.val(),
          ai: stimulusController ? stimulusController.isAi : false,
          aspect_ratios: stimulusController ? stimulusController.aspectRatiosValue.join(",") : ""
        },
        success: function(data) {
          appCustomerSpace.Loader().stop();
          if (data.response && stimulusController) {
            stimulusController.handleImageEdited(data.image_content, data.component_body_html);
          }
          modal.close();
        },
        error: function() {
          appCustomerSpace.Loader().stop();
          console.error('Error updating image content');
        }
      });
    },

    _constrainSelection: function(detail) {
      var selection = this.cropper.getCropperSelection();
      var cropperImage = this.cropper.getCropperImage();
      var canvas = this.cropper.getCropperCanvas();
      if (!selection || !cropperImage || !canvas) return;

      var canvasRect = canvas.getBoundingClientRect();
      var imageRect = cropperImage.getBoundingClientRect();

      var width = Math.min(detail.width, imageRect.width);
      var height = Math.min(detail.height, imageRect.height);

      var minX = imageRect.x - canvasRect.x;
      var minY = imageRect.y - canvasRect.y;
      var maxX = minX + imageRect.width - width;
      var maxY = minY + imageRect.height - height;

      var x = Math.max(minX, Math.min(detail.x, maxX));
      var y = Math.max(minY, Math.min(detail.y, maxY));

      selection.x = x;
      selection.y = y;
      selection.width = width;
      selection.height = height;
      selection.$render();
      this._updateShadeClip();
    },

    _updateShadeClip: function() {
      if (!this.cropper || !this.$shade) return;

      var canvas = this.cropper.getCropperCanvas();
      var image = this.cropper.getCropperImage();
      if (!canvas || !image) return;

      var canvasRect = canvas.getBoundingClientRect();
      var imageRect = image.getBoundingClientRect();

      var imgX = imageRect.left - canvasRect.left;
      var imgY = imageRect.top - canvasRect.top;
      var imgW = imageRect.width;
      var imgH = imageRect.height;

      var shade = this.$shade;
      var sX = shade.x || 0;
      var sY = shade.y || 0;
      var sW = shade.width || 0;
      var sH = shade.height || 0;

      var top = imgY - sY;
      var left = imgX - sX;
      var bottom = (sY + sH) - (imgY + imgH);
      var right = (sX + sW) - (imgX + imgW);

      shade.style.clipPath =
        'inset(' + top + 'px ' + right + 'px ' + bottom + 'px ' + left + 'px)';
    },

    close: function() {
      if (this.cropper) {
        this.cropper.destroy();
        this.cropper = null;
      }
      EditImageContent.__super__.close.apply(this, arguments);
    }
  });

  return EditImageContent;

})(appCustomerSpace.Modal);
